import type { KgInsight } from '@api';
import { Button } from '@design';
import { FollowThemeButton } from '@terminal/components/follow-theme-button/FollowThemeButton';
import { RenderFeatureFlag } from '@terminal/components/render-feature-flag/RenderFeatureFlag';
import { WatchlistTrigger } from '@terminal/components/watchlist/watchlist-trigger/WatchlistTrigger';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './KgInsightPreview.module.scss';

export type KgInsightHeaderButtonProps = {
  subject: KgInsight['subject'];
};

export const KgInsightHeaderButton = ({
  subject,
}: KgInsightHeaderButtonProps) => {
  const { t } = useTranslation(['insights', 'common']);

  if (subject.type === 'entity') {
    return (
      <WatchlistTrigger
        tag={subject.id}
        dropdownProps={{
          strategy: 'fixed',
          placement: 'bottom',
          inPortal: false,
        }}
        renderTrigger={isInWatchlist => (
          <Button
            className={clsx(styles.watchlistButton, {
              [styles.active]: isInWatchlist,
            })}
            data-testid="watchlist-button"
            label={
              isInWatchlist
                ? t('common:components.watchlistBtn.watching')
                : t('common:components.watchlistBtn.addToWatchlistLabel')
            }
            size="xsmall"
            variant="tertiary"
            iconName={isInWatchlist ? 'Checkmark' : 'Add'}
          />
        )}
      />
    );
  }

  if (subject.type === 'theme') {
    return (
      <RenderFeatureFlag requiredFlag="followed_themes">
        <FollowThemeButton themeId={subject.id} />
      </RenderFeatureFlag>
    );
  }

  return null;
};
